import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../../Actions/AxiosInstance";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import { ReducersTypes } from "../../../../../../../Constants";
import LeavePlan from "..";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  leaveid: null,
  LeaveList: [],
  isoverutilizationallowed: false,
  excesspaidlimit: null,
  altleave: [],
  altleaveid: null,
  altleavetypeid: null,
  altleavecategoryid: null,
};
class LeaveApplication extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };
  }

  componentDidMount() {
    this.getLeaveList();
  }

  getLeaveList() {
    const { details, leaveid } = this.props.InitLeavesPolicy;
    const leavepolicyid = this.props.InitLeavesPolicy.leavepolicyid
      ? this.props.InitLeavesPolicy.leavepolicyid
      : null;
    let leavetypeids = [];
    // if (details.length > 0) {
    //   // for (const detail of details) {
    //   //   leavetypeids.push(detail.leavetypeid);
    //   // }
    //   leavetypeids = [4, 3];
    // } else {
    //   leavetypeids = [4, 3];
    // }
    leavetypeids = [4, 3];

    if (leavepolicyid) {
      instance
        .post(`/leaves/leavelistbypolicyid`, {
          leavepolicyid,
          leavetypeids,
        })
        .then(
          (result) => {
            this.setState(
              {
                LeaveList: leaveid
                  ? result.data.result.filter(
                      (leave) => leave.displayvalue != leaveid,
                    )
                  : result.data.result,
              },
              () => {
                this.SetValues(this.props);
              },
            );
          },
          (error) => {
            const CommonError = error.response
              ? error.response.data.error.message
              : error.message;
            this.props.enqueueSnackbar(CommonError, { variant: "error" });
          },
        );
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      const InitLeavesPolicy = props.InitLeavesPolicy.policy[ParentIndex];
      this.setState(
        {
          ParentIndex,
          leavetypeid: props.leavetypeid,
          altleaveid: InitLeavesPolicy.overutilizationpolicy
            ? InitLeavesPolicy.overutilizationpolicy.altleaveid
            : null,
          isoverutilizationallowed: InitLeavesPolicy.isoverutilizationallowed,
          excesspaidlimit: InitLeavesPolicy.overutilizationpolicy
            ? InitLeavesPolicy.overutilizationpolicy.excesspaidlimit
            : this.state.excesspaidlimit,
          excessleaveactiontypeid: InitLeavesPolicy.overutilizationpolicy
            ? InitLeavesPolicy.overutilizationpolicy.excessleaveactiontypeid
            : this.state.excessleaveactiontypeid,
          altexcessleaveactiontypeid: InitLeavesPolicy.overutilizationpolicy
            ? InitLeavesPolicy.overutilizationpolicy.altexcessleaveactiontypeid
            : this.state.altexcessleaveactiontypeid,
          altleavetyepid: InitLeavesPolicy.overutilizationpolicy
            ? InitLeavesPolicy.overutilizationpolicy.altleavetyepid
            : this.state.altleavetypeid,
          altleavecategoryid: InitLeavesPolicy.overutilizationpolicy
            ? InitLeavesPolicy.overutilizationpolicy.altleavecategoryid
            : this.state.altleavecategoryid,
        },
        () => {
          const id = this.state.altleaveid;
          let altleave = [];
          if (id) {
            altleave = this.state.LeaveList.find((x) => x.displayvalue == id);
            this.setState({ altleave });
          }
        },
      );
    } else {
      // this.setState({ ...ParentState }, () => this.getLeaveList())
    }
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () =>
        this.SetValues(props),
      );
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      isoverutilizationallowed: this.state.isoverutilizationallowed,
    };
    this.props.InitLeavesPolicy.policy[ParentIndex].overutilizationpolicy = {
      excesspaidlimit: this.state.excesspaidlimit,
      excessleaveactiontypeid: this.state.excessleaveactiontypeid,
      altexcessleaveactiontypeid: this.state.altexcessleaveactiontypeid,
      altleaveid: this.state.altleaveid,
      altleavetyepid: this.state.altleavetypeid,
      altleavecategoryid: this.state.altleavecategoryid,
    };
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  CommonNumberChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (
        Number(event.target.value) > Number(max) ||
        Number.isNaN(event.target.value)
      )
        value = this.state[name];
      else value = Number(event.target.value);
      this.setState({ [name]: value }, () => this.UpdateReducer());
    }
  };

  handleChange(name, ...arg) {
    switch (name) {
      case "isoverutilizationallowed": {
        this.setState(
          {
            [name]: arg[0],
            excessleaveactiontypeid: null,
            excesspaidlimit: 0,
            altleaveid: null,
            altleave: [],
            altexcessleaveactiontypeid: null,
          },
          () => {
            this.UpdateReducer();
          },
        );
        break;
      }
      case "excessleaveactiontypeid": {
        this.setState(
          {
            [name]: arg[0],
            altexcessleaveactiontypeid: null,
            altleave: [],
            altleaveid: null,
            excesspaidlimit: 0,
          },
          () => {
            this.UpdateReducer();
          },
        );
        break;
      }
      case "altexcessleaveactiontypeid": {
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      }
      case "altleave": {
        console.log("name ,arg", name, arg[0]);
        this.setState({ [name]: arg[0] }, () => this.options(name, arg[0]));
        break;
      }
      default:
        break;
    }
  }

  options(name, selected) {
    console.log("selected: ", selected);
    const leavecategoryid = selected && selected.leavecategoryid;
    const arg = selected ? selected.displayvalue : null;
    console.log("arg: ", name, arg);
    const arg1 = selected ? selected.leavetypeid : null;
    console.log("arg12: ", arg1);
    if (name == "altleave") {
      this.setState(
        {
          altleaveid: arg,
          altleavetypeid: arg1,
          altleavecategoryid: leavecategoryid,
        },
        () => this.UpdateReducer(),
      );
    }
  }

  render() {
    const language = this.props.Language.leaveapplication;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className="margin-top-10">
          <div className="inner-wrapper opaque">
            <p className="form-main-header margin-top-20">
              <FormattedMessage
                id="__LbLeaveOverutilization"
                defaultMessage="Leave Overutilization"
              />
            </p>
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbHowDoWeHandleLeave"
                defaultMessage="How do we handle leave applications which exceed the available leave balance?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() =>
                this.handleChange("isoverutilizationallowed", false)
              }
              aria-expanded={this.state.isoverutilizationallowed == false}
            >
              <span>
                {" "}
                <FormattedMessage
                  id="LbDontAllowLeave"
                  defaultMessage="Don’t allow leave applications in excess of available balance"
                />{" "}
              </span>
              {this.state.isoverutilizationallowed == false ? (
                <span className="floatright">
                  {" "}
                  <img src={CheckImg} height="20" />{" "}
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div
              className="depedent-select-list"
              onClick={() =>
                this.handleChange("isoverutilizationallowed", true)
              }
              aria-expanded={this.state.isoverutilizationallowed == true}
            >
              <span>
                {" "}
                <FormattedMessage
                  id="LbAllowLeave"
                  defaultMessage="Allow leave applications in excess of available balance, but follow the below rules"
                />{" "}
              </span>
              {this.state.isoverutilizationallowed == true ? (
                <span className="floatright">
                  {" "}
                  <img src={CheckImg} height="20" />{" "}
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div className="et-level2">
              <Collapse
                in={this.state.isoverutilizationallowed}
                timeout={2}
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <div
                  className="depedent-select-list"
                  aria-expanded={this.state.excessleaveactiontypeid == 1}
                >
                  <span>
                    {" "}
                    <FormattedMessage
                      id="LbCountExcessAsPaid"
                      defaultMessage="By default, count the excess leaves as paid (leave balance will go into -negative)"
                    />{" "}
                  </span>
                  <span
                    onClick={() =>
                      this.handleChange("excessleaveactiontypeid", 1)
                    }
                  >
                    {this.state.excessleaveactiontypeid == 1 ? (
                      <span className="floatright">
                        {" "}
                        <img src={CheckImg} height="20" />{" "}
                      </span>
                    ) : (
                      <span className="not-selected " />
                    )}
                  </span>
                </div>
                {/* <div className="et-level3">
                  <Collapse
                    in={this.state.excessleaveactiontypeid == 1 ? true : false}
                    timeout={2}
                    unmountOnExit
                    className="padding30 overflow-initial"
                  >
                    <FormattedMessage
                      id="LbLimitOverUtilization"
                      defaultMessage="Limit over-utilization of leave up to"
                    />
                    <InputValues
                      min="1"
                      max="300"
                      field="excesspaidlimit"
                      onChange={this.CommonNumberChange.bind(this, "excesspaidlimit", 300)}
                      value={this.state.excesspaidlimit}
                      defaultvalue={this.state.excesspaidlimit}
                    />
                    <span className="number-wrapper">
                      <input
                        className="seatlimit"
                        type="number"
                        min="1"
                        max="300"
                        onChange={this.handleChange.bind(this, "excesspaidlimit")}
                        value={this.state.excesspaidlimit}
                      />
                    </span>
                    <FormattedMessage id="LbDaysInExcess" defaultMessage=" days in excess" />
                  </Collapse>
                </div> */}
                <div
                  className="depedent-select-list"
                  aria-expanded={this.state.excessleaveactiontypeid == 2}
                >
                  <span>
                    {" "}
                    <FormattedMessage
                      id="LbCountExcessAsUnpaid"
                      defaultMessage="By default, count the excess leaves as unpaid (‘Unpaid Leave’ type will be used for excess days)"
                    />{" "}
                  </span>
                  <span
                    onClick={() =>
                      this.handleChange("excessleaveactiontypeid", 2)
                    }
                  >
                    {this.state.excessleaveactiontypeid == 2 ? (
                      <span className="floatright">
                        {" "}
                        <img src={CheckImg} height="20" />{" "}
                      </span>
                    ) : (
                      <span className="not-selected " />
                    )}
                  </span>
                </div>
                <div
                  className="depedent-select-list"
                  aria-expanded={this.state.excessleaveactiontypeid == 3}
                >
                  <span className="inline-display">
                    <p className="t-14">
                      <FormattedMessage
                        id="LbDeductFrom"
                        defaultMessage="Deduct excess leaves from"
                      />
                    </p>
                    <span className="width113p">
                      <Select
                        autofocus
                        placeholder="Select"
                        options={this.state.LeaveList}
                        getOptionLabel={(option) => option.displayname}
                        getOptionValue={(option) => option.displayvalue}
                        onChange={this.handleChange.bind(this, "altleave")}
                        value={this.state.altleave}
                        isDisabled={this.state.excessleaveactiontypeid != 3}
                      />
                    </span>
                    <p className="t-14 margin-top-8">
                      <FormattedMessage
                        id="LbLeavesBalanceInsufficient"
                        defaultMessage="and if this leave’s available balance is insufficient"
                      />
                    </p>
                  </span>
                  <span
                    onClick={() =>
                      this.handleChange("excessleaveactiontypeid", 3)
                    }
                  >
                    {this.state.excessleaveactiontypeid == 3 ? (
                      <span className="floatright">
                        {" "}
                        <img src={CheckImg} height="20" />{" "}
                      </span>
                    ) : (
                      <span className="not-selected " />
                    )}
                  </span>
                </div>
                <div className="et-level2">
                  <Collapse
                    in={!!this.state.altleaveid}
                    timeout={2}
                    unmountOnExit
                    className="padding30 overflow-initial"
                  >
                    <div
                      className="depedent-select-list"
                      aria-expanded={this.state.altexcessleaveactiontypeid == 1}
                    >
                      <span>
                        {" "}
                        <FormattedMessage
                          id="LbCountExcessAsPaid"
                          defaultMessage="By default, count the excess leaves as paid (leave balance will go into -negative)"
                        />{" "}
                      </span>
                      <span
                        onClick={() =>
                          this.handleChange("altexcessleaveactiontypeid", 1)
                        }
                      >
                        {this.state.altexcessleaveactiontypeid == 1 ? (
                          <span className="floatright">
                            {" "}
                            <img src={CheckImg} height="20" />{" "}
                          </span>
                        ) : (
                          <span className="not-selected " />
                        )}
                      </span>
                    </div>
                    <div
                      className="depedent-select-list"
                      aria-expanded={this.state.altexcessleaveactiontypeid == 2}
                    >
                      <span>
                        {" "}
                        <FormattedMessage
                          id="LbCountExcessAsUnpaid"
                          defaultMessage="By default, count the excess leaves as unpaid (‘Unpaid Leave’ type will be used for excess days)"
                        />{" "}
                      </span>
                      <span
                        onClick={() =>
                          this.handleChange("altexcessleaveactiontypeid", 2)
                        }
                      >
                        {this.state.altexcessleaveactiontypeid == 2 ? (
                          <span className="floatright">
                            {" "}
                            <img src={CheckImg} height="20" />{" "}
                          </span>
                        ) : (
                          <span className="not-selected " />
                        )}
                      </span>
                    </div>
                  </Collapse>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}
LeaveApplication.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(LeaveApplication)));
